import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getSideBarfilesActions,
  setGrievanceAction,
  setThecountBasedRenders,
  setTheoptions,
  setThegrieveacncedeleteActions, ///delete
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import GrievanceTypeCreate from "./GrievanceTypeCreate";
import Delete from "../../AppComponent/Popup/Delete";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";

const Grievence = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);
  const [EditID, setEditId] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const [GrivanceTypeCreate, setGrievanceCrea] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();

  const FileterState = {
    status: "",
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  console.log(state.NumberCounts, "fsdf");
  const options = [
    { value: state.NumberCounts.Option1, label: "All" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  console.log(selectVal, "selectVal");

  const HandleDeletes = () => {
    if (DeleteId != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteId: DeleteId,
        currentPage: currentPage,
      };
      dispatch(setThegrieveacncedeleteActions(payload, setDeletepopup(false)));
    }
  };

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
    };

    dispatch(setGrievanceAction(payload));
  }, [selectVal, dtpageindex]);
  console.log(state.grievanceTypeCall, "grievanceTypeCall");

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);

    setSelected(sel);
    SetStates(true);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));

    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,

        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };

  //--------Place---Holder----dispatch======
  useEffect(() => {
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage < state.grievanceTypeCall.Total_Count) {
      setCurrentPage(newpages + 1);

      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
      };
      dispatch(setGrievanceAction(pageEntries));
    }
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
 
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
        };

        dispatch(setGrievanceAction(payload));
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
    debouncedSearch(e);
    // if (e != undefined && e !== "") {
    //   const payload = {
    //     search: e,
    //     page_size: dtpagesize,
    //     page: 1,
    //   };

    //   dispatch(setGrievanceAction(payload));
    // }
    // if (e == "" && search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //   };
    //   dispatch(setGrievanceAction(payload));
    // }
  }
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const columns = [
    {
      Header: "Grievance Type",
      accessor: "grievance_type",
    },
    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.purpose != null &&
              row.row.original.purpose != "" ? (
                <span>{row.row.original.purpose}</span>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditId(row.row.original.id);
                  setGrievanceCrea(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletepopup(true);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>

            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      {" "}
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Grievance Type</h3>

          </div>

          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setGrievanceCrea(true);
                setEditId("");
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>
<br/>
        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.grievanceTypeCall.grievanceDatas}
            columns={columns}
            totalItems={state.grievanceTypeCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
          dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.grievanceTypeCall.Total_Count}
            // value={state.NumberCounts.Options}
            // options={options}
            // Filter={Filter}
            // count={count}
            // ClearState={ClearState}
            // placeHold={place}
            Filter={true}
            NoFilter ={true}
          />
        </div>
      </div>
      {GrivanceTypeCreate ? (
        <>
          <GrievanceTypeCreate
            setShow={setGrievanceCrea}
            currentPage={dtpageindex}
            EditId={EditID}
            search={search}
            show={GrivanceTypeCreate}
          />
        </>
      ) : null}
      {GrivanceTypeCreate && EditID != undefined ? (
        <GrievanceTypeCreate
          show={GrivanceTypeCreate}
          setShow={setGrievanceCrea}
          currentPage={dtpageindex}
          EditID={EditID}
          search={search}
        />
      ) : null}
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletepopup}
          onSubmit={HandleDeletes}
          Content={"Do you want to delete the Grievance Type"}

        />
      ) : null}
    </>
  );
};

export default Grievence;
